module.exports = __webpack_public_path__ + "../resources/img/ic-re-notification-default.31d1ff08.svg";